<template>
  <div
    class="modal fade"
    id="msgAfterLogin"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
    data-backdrop="static"
    ref="msgAfterLogin"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="ribbon ribbon-sm ribbon-reverse">
          <span class="ribbon-inner bg-light"
            >{{ msgIdx + 1 }}/{{ importantMessageCount }}</span
          >
        </div>
        <div class="modal-header">
          <h4 class="modal-title pr-4" id="exampleModalLongTitle">
            {{ msg.messageTitle }}
          </h4>
        </div>
        <div class="modal-body message-body text-break" v-html="msg.messageContent">
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" @click.prevent="action" class="btn-info btn-lg">
            我知道了
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';

export default {
  name: 'MsgAfterLogin',

  data: () => ({
    msgIdx: 0,
  }),

  computed: {
    ...mapGetters(['importantMessageCount', 'importantMessageList']),

    msg() {
      const _msg = this.importantMessageList[this.msgIdx];
      return _msg ? _msg : {};
    },
  },

  methods: {
    ...mapActions(['readImportantMessage']),

    action() {
      if (this.msg.messageId) {
        this.readImportantMessage({
          messageId: this.msg.messageId,
        });
        this.msgIdx++;
        if (this.importantMessageCount <= this.msgIdx) {
          $(this.$refs.msgAfterLogin).modal('hide');
        }
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
